"use client";

import React from "react";
import { Phone, ArrowRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function CallToAction() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="calltoaction" data-nav="light" className="relative overflow-hidden bg-background py-16 md:py-20 lg:py-24 border-t border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 flex justify-center">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="w-full max-w-2xl rounded-2xl border border-border bg-card p-6 sm:p-12 md:p-16 shadow-sm text-center">
          <h2 className="font-default text-2xl sm:text-3xl md:text-4xl font-bold text-card-foreground tracking-tight">
            Request a Quote for a 53-Foot Reefer Trailer
          </h2>

          <p className="mt-4 text-base md:text-lg text-muted-foreground leading-relaxed">
            Tell us your rental dates, delivery location, intended use, and temperature requirements. Availability and delivery are confirmed individually.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 shadow-sm" asChild>
              <Link to="/ContactRequestAQuotePage">
                <span>Request a Quote</span>
                <ArrowRight className="size-4" aria-hidden="true" />
              </Link>
            </Button>

            <Button variant="outline" size="lg" className="w-full sm:w-auto border-border text-foreground hover:bg-accent hover:text-accent-foreground" asChild>
              <a href="tel:2135218821">
                <Phone className="size-4 text-primary" aria-hidden="true" />
                <span>213-521-8821</span>
              </a>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}